/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

/* eslint-disable */

function plotData(addTo, values) {
  let Lawson, Climate, Sensitivity
  console.log(values)
  const { allConfigs, allLocations, allSeasons } = addTo
  allLocations.forEach(locId => {
    allConfigs.forEach(config => {
      allSeasons.forEach(season => {
        console.log(locId, config, season, allConfigs)
        addTo.locations[locId].plots[config] =
          addTo.locations[locId].plots[config] || {}
        addTo.locations[locId].plots[config][season] =
          addTo.locations[locId].plots[config][season] || {}

        // find Lawson and assign it
        Lawson = values.find(v => {
          if (
            v.fields.location === locId &&
            v.fields.config === config &&
            v.fields.season === season &&
            v.fields.plotType === 'Lawson'
          )
            return true
        }).original.src

        // find climate and assign it
        Climate = values.find(v => {
          if (v.fields.season === season && v.fields.plotType === 'Climate')
            return true
        }).original.src

        // find Sensitivity and assign it
        Sensitivity = values.find(v => {
          if (
            v.fields.config === config &&
            v.fields.location === locId &&
            v.fields.plotType === 'Sensitivity'
          )
            return true
        }).original.src

        addTo.locations[locId].plots[config][season] = {
          Lawson,
          Climate,
          Sensitivity,
        }
      })
    })
  })

  return addTo
}

export default plotData
